<template>
  <div class="map">
    <!-- {{ mapConfig }} -->
    <div v-if="locationFilter && mapConfig" class="map-wrap">
      <div class="legend">
        <map-legend
          v-if="mapConfig.hasLegend && allTimeValues"
          :lite="lite"
          :config="mapConfig"
          :all-time-values="allTimeValues"
          :data-card="dataCard"
        />
        <!-- <div v-if="mapConfig.hasLegend && mapConfig.scaleOption === 'gradient'" class="legend-wrapper">
          <div class="color-wrapp" :style="'background:' + cssGradient(mapConfig.colorRange)" />
          <div class="labels-wrapper">
            <span>{{ mapDataLimits.parsedMin }}</span>
            <span>{{ mapDataLimits.parsedMax }}</span>
          </div>
        </div>
        <div v-else-if="mapConfig.hasLegend && mapConfig.scaleOption === 'steps'" class="legend-wrapper">
          <div class="colors-wrapper">
            <div v-for="(step,i) in legendSteps" :key="i" class="color-wrapper">
              <div class="color-box" :style="'backgroundColor: ' + getColor(step.min)" />
              <span v-if="i<legendSteps.length-1" class="threshold">{{ d3_format(".2s")(step.max) }}</span>
            </div>
          </div>
        </div> -->
      </div>

      <l-map
        :options="mapOptions"
        :bounds="bounds"
        style="z-index: 1"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        @mousemove="updateMousePos"
        @mouseout="closeMousePos"
      >
        <l-control-layers v-if="!lite" position="bottomleft" />
        <l-control-attribution v-if="!lite" position="bottomright" prefix="" />
        <l-control-zoom v-if="!lite" position="topright" />
        <l-control-scale
          v-if="!lite"
          position="bottomright"
          :imperial="false"
          :metric="true"
        />
        <l-control v-if="!lite && mousePosV" position="bottomright">
          <span>{{ $t('lat') + ': ' + lat + ', ' + $t('lng') + ': ' + lng }}</span>
        </l-control>
        <l-tile-layer
          v-if="!lite"
          key="XYZ Example"
          attribution="Ajuntament de Barcelona (Fora terme municipal: AMB, &copy; CARTO, &copy; OpenStreetMaps contributors)"
          :url="url"
          :name="$t('map_base')"
          :visible="true"
          layer-type="base"
          :tile-size="256"
        />
        <l-image-overlay
          :name="$t('map_no_base')"
          layer-type="base"
          :visible="false"
          url="/blank.png"
          :bounds="bounds"
        />
        <l-control v-if="!geojson && !loading" position="topright">
          <div style="display: flex; justify-content: center; width: 100vw; margin-top: 30px">
            <span style="font-size: 18px; background-color: white; padding: 0 15px">{{
              $t('geo_not_supported')
            }}</span>
          </div>
        </l-control>
        <!-- NO HACE FALTA, ya lo lleva el pivotCompoentnt y el injectedChart, no?!-->
        <!-- <l-control v-if="loading" position="topright">
          <div style="display: flex; justify-content: center; width: 100vw; margin-top: 30px;">
            <span style="font-size: 18px; background-color: white; padding: 0 15px;">{{ $t('loading') }}</span>
          </div>
        </l-control> -->
        <l-geo-json
          ref="geojson"
          :geojson="geojson"
          :options="geoOptions"
          :options-style="styleFunction"
          name="geojson"
          :visible="geoVisibility"
          @update:visible="changeGeoVisibility"
          @mouseout="closeMousePos"
        />
      </l-map>
    </div>
  </div>
</template>

<script>
// import { extent as d3_extent } from 'd3-array'
import { cssGradient, colorScaleFromConfig } from '../../utils/colorUtils'
import { format as d3_format } from 'd3-format'

import { getDimensionsData } from '@/services/table-api'
import 'leaflet/dist/leaflet.css'
import { /*L,*/ /*CRS,*/ latLng, icon } from 'leaflet'
import {
  LMap,
  LTileLayer,
  LGeoJson,
  LControlLayers,
  LControlZoom,
  LImageOverlay,
  LControl,
  LControlAttribution,
  LControlScale,
} from 'vue2-leaflet'

import { getGeojson } from '@/services/api'
import MapLegend from './MapLegend.vue'
import { maskValue } from '@/utils/formatUtils'

export default {
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LImageOverlay,
    LControlLayers,
    LControlZoom,
    LControl,
    LControlAttribution,
    LControlScale,
    MapLegend,
  },
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: {
    pivotConfig: {
      type: Object,
    },
    mapConfig: {
      type: Object,
    },
    dimensionMetas: {
      type: Object,
    },
    data: {},
    dataCard: {},
    tooltipFunction: {
      type: Function,
    },
    options: {
      type: Object,
    },
    allTimeValues: {
      type: Array,
    },
    lite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lat: 0,
      lng: 0,
      mousePosV: false,
      mapEditOpen: false,
      defaultPivotConfig: null, //pivotConfigFile

      hasLegend: true,
      //crs: customCrs,
      zoom: 10.5,
      center: latLng(41.390167, 2.1733408),
      url: 'https://cdn-geo.bcn.cat/XYZ/PLANOLBCN/{z}/{x}/{y}.png',
      mapOptions: {
        zoomSnap: 0.1,
        zoomControl: false,
        minZoom: 10.5,
        attributionControl: false,
        scrollWheelZoom: false,
        doubleClickZoom: !this.lite,
      },
      enableTooltip: true,
      geojson: null,
      geoVisibility: true,
      loading: true,
      opacity: 0.3,

      withPopup1: latLng(41.390167, 2.1733408),
      withPopup2: latLng(41.380367, 2.1745408),
      iconMaker: icon({
        iconUrl:
          'https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/1.0.4/images/marker-icon-2x.png',
        iconSize: [24, 37],
        iconAnchor: [12, 37],
      }),
    }
  },
  computed: {
    bounds() {
      //para los "this.lite" ya sirve el mismo bounds, pero para mobile que es muy estrecho quedava mal...
      if (this.isMobile)
        return [latLng(41.48, 2.13), latLng(41.31, 2.15)]
      else 
        return [latLng(41.47, 2.13), latLng(41.32, 2.16)]
    },
    flatDimensionsOptions() {
      let tmp = { ...this.options }
      let locDim = this.locationFilter.id.replace('_type', '')
      tmp[locDim] = tmp[locDim].filter(el => el.type === this.locationFilter.values[0].type)
      return tmp
    },
    flatDimensionsOptionsDict(){
      return Object.keys(this.flatDimensionsOptions).reduce((parent, key)=>{
        parent[key] = this.flatDimensionsOptions[key].reduce((res,o)=>{
          res[o.id] = o
          return res
        },{})
        return parent
      },{})
    },
    internalPivotConfig: {
      get() {
        return JSON.parse(JSON.stringify(this.pivotConfig))
      },
      set(v) {
        // no se usa... en realidata el MAP no DEBE tocar nada del pivotConfig, pero algo hacia...
        this.$emit('change-pivot-config', v)
      },
    },
    locationDim() {
      let self = this
      return Object.keys(self.dimensionsInfo.dimensionMetas).find(elem => {
        return self.dimensionsInfo.dimensionMetas[elem].type === 'location'
      })
    },
    locationFilter() {
      if (!this.internalPivotConfig) return null
      let locFil = this.internalPivotConfig.dimensions.find(el => {
        return el.role === 'types' && el.id.slice(0, el.id.length - 5) === this.locationDim
      })
      let finded = locFil.values.find(el => el.value === 'districte' || el.value === 'Districte')
      if (finded) locFil.values = [finded]
      return locFil
    },
    colorScale() {
      return colorScaleFromConfig(
        this.mapConfig,
        this.mapData.map(d => d.value)
      )
    },
    mapData() {
      let arr = []

      if (this.data) {
        let dims = this.internalPivotConfig.dimensions.filter(d => d.id.indexOf('_type') < 0)
        let h = this.data?.header[0].map(h => {
          return h.value
        })
        this.data?.values.forEach(row => {
          let rowOb = dims.reduce((ob, dim) => {
            if (dim.role === 'filters') ob[dim.id] = dim.values[0].value
            else {
              let idx = h.findIndex(hh => hh === dim.id)
              ob[dim.id] = row[idx]?.value || row[idx]
            }
            return ob
          }, {})
          let valueIndex = 1
          rowOb.value = row[valueIndex]?.value || row[valueIndex]
          rowOb.secret = row[valueIndex]?.secret || false
          arr.push(rowOb)
         
        })
      }

      return arr
    },
    timeDimId() {
      return Object.keys(this.dimensionsInfo.dimensionMetas).find(elem => {
        return this.dimensionsInfo.dimensionMetas[elem].type === 'time'
      })
    },
    geoOptions() {
      return {
        onEachFeature: this.onEachFeatureFunction,
      }
    },
   
    dimensionsInfo() {
      return getDimensionsData(this.dataCard)
    },
    onEachFeatureFunction() {
      if (!this.enableTooltip) {
        return () => {}
      } else {
        return (feature, layer) => {
          let self = this
          let rowsDim = this.locationDim
          if (this.enableTooltip) {
            let elementValue = this.mapData.find(el => {
              // let elObj = self.flatDimensionsOptions[rowsDim].find(d => d.id === el[rowsDim])
              let elObj = self.flatDimensionsOptionsDict[rowsDim][el[rowsDim]]
              // HARDCODED A 3 VALUES BARRI/DISTRICTE/MUNICIPI TO LOCAL GEOJSONS
              if (
                elObj?.order &&
                feature.properties.TIPUS_UA &&
                (feature.properties.TIPUS_UA === 'BARRI' ||
                  feature.properties.TIPUS_UA === 'DISTRICTE')
              ) {
                return parseInt(feature.properties.CODI_UA) === elObj.order
              } else if (
                elObj?.order &&
                feature.properties.TIPUS_UA &&
                feature.properties.TIPUS_UA === 'SEC_CENS'
              ) {
                return (
                  parseInt(feature.properties.DISTRICTE + feature.properties.SEC_CENS) ===
                  elObj.order
                )
              } else if (
                elObj?.order &&
                feature.properties.TIPUS_UA &&
                feature.properties.TIPUS_UA === 'AEB'
              ) {
                return parseInt(feature.properties.AEB) === elObj.order
              } else {
                return elObj?.label === feature.properties.NOM
              }
              // return elObj.label === feature.properties.NOM
            })
            let timeDim = self.timeDimId
            let selectedTimeDim = self.pivotConfig.dimensions.find(di => di.id === timeDim)
              .values[0].value
            let labelTime = self.flatDimensionsOptions[timeDim].find(
              t => selectedTimeDim === t.id
            ).label
            let formatedFilterString = ''
            let qFilters = self.pivotConfig.dimensions.filter(
              dim => dim.role === 'filters' && dim.id !== timeDim
            )
            qFilters.forEach(el => {
              if (formatedFilterString !== '') {
                formatedFilterString += ', '
              }
              formatedFilterString +=
                self.dimensionsInfo.dimensionMetas[el.id].label + ': ' + self.flatDimensionsOptions[el.id].find(
                  t => el.values[0].value === t.id
                ).label
            })

            layer.bindTooltip(
              `<div style="font-size: 16px; font-weight: 600">${
                elementValue ? maskValue(elementValue.value, self.dataCard, elementValue.secret) : 'undefined'
              }</div>
              <div style="font-size: 10px; margin-bottom: 10px">${formatedFilterString}</div>
              <div style="font-size: 10px">${labelTime}</div>
              <div style="display: flex; gap: 5px; width: 100%; align-items: center;">
                <div style="width: 8px; height: 8px; border-radius: 50%; background-color: ${
                  elementValue ? this.getColor(elementValue.value) : 'gray'
                };"></div>
                <span style="font-weight: 400; font-size: 14px">${
                  feature.properties.TIPUS_UA === 'AEB'
                    ? feature.properties.AEB
                    : feature.properties.TIPUS_UA === 'SEC_CENS'
                    ? parseInt(feature.properties.DISTRICTE + feature.properties.SEC_CENS)
                    : feature.properties?.NOM
                }</span>
              </div>`,
              { permanent: false, sticky: true }
            )
          }
        }
      }
    },
  },
  watch: {
    fakeGeojson() {
      if(this.geojson?.name !== this.fakeGeojson?.name) this.geojson = this.fakeGeojson
      this.loading = false
    },
    mapData() {
      this.loading = true
      if (this.mapData.length === 0) {
        this.enableTooltip = false
        this.loading = false
      } else this.enableTooltip = true
      setTimeout(()=>{
        if(!this.$asyncComputed.fakeGeojson.updating) this.resetGeoStyles()
      },10)
    },
    locationFilter() {
      this.loading = true
    },
    mapConfig: {
      handler() {
        this.resetGeoStyles()
      },
      deep: true,
    },
  },
  mounted() {
    let defaultMapConfig = {
      scaleSteps: 5,
      interpolationType: 'linear',
      scaleOption: 'gradient',
      opacityMapValue: 50,
      hasLegend: true,
      colorRange: ['#BBD6E8', '#15537E'],
    }
    //Disparamos SI O SI el merged con el default, pero weno, como solo es "onmounted"...
    this.$emit('change-map-config', { ...defaultMapConfig, ...this.mapConfig })
  },
  asyncComputed: {
    fakeGeojson() {
      return this.locationFilter && getGeojson(this.locationFilter.values[0].value)
    },
  },
  methods: {
    cssGradient,
    d3_format,
    changeNumSteps(num) {
      this.mapConfig.scaleSteps = parseInt(num)
    },
    changeInterpolation(value) {
      this.mapConfig.interpolationType = value
    },
    showShareModal() {
      this.$modal.show('modal-share')
    },

    resetToDefault() {
      console.log('reset to default')
    },
    changeGeoVisibility(showed) {
      this.geoVisibility = showed
    },
    resetGeoStyles() {
      if (this.$refs.geojson) {
        let geoj = this.$refs.geojson
        geoj.setOptions(this.geoOptions)
        this.loading = false
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    getColor(d) {
      return this.colorScale(d)
    },
    updateMousePos(event) {
      this.mousePosV = true
      this.lat = Math.round(event.latlng.lat * 100000) / 100000
      this.lng = Math.round(event.latlng.lng * 100000) / 100000
    },
    closeMousePos() {
      this.mousePosV = false
    },
    styleFunction(feature) {
      //llamamos los computeds para que pille los cambios generados en las las variables
      let opacityPick = this.mapConfig.opacityMapValue
      this.colorScale
      let self = this
   
      //volvemos a setear la opacity para que pille los cambios despues de cambiar el geojson
      opacityPick = self.mapConfig.opacityMapValue
      let rowsDim = self.pivotConfig.dimensions.find(f => f.id === self.locationDim)

      let element = self.mapData.find(el => {
        let elObj = self.flatDimensionsOptionsDict[rowsDim.id][el[rowsDim.id]]
        //HARDCODED A 3 VALUES BARRI/DISTRICTE/MUNICIPI TO LOCAL GEOJSONS
        if (
          elObj?.order &&
          feature.properties.TIPUS_UA &&
          (feature.properties.TIPUS_UA === 'BARRI' || feature.properties.TIPUS_UA === 'DISTRICTE')
        ) {
          return parseInt(feature.properties.CODI_UA) === elObj.order
        } else if (
          elObj?.order &&
          feature.properties.TIPUS_UA &&
          feature.properties.TIPUS_UA === 'SEC_CENS'
        ) {
          return (
            parseInt(feature.properties.DISTRICTE + feature.properties.SEC_CENS) === elObj.order
          )
        } else if (
          elObj?.order &&
          feature.properties.TIPUS_UA &&
          feature.properties.TIPUS_UA === 'AEB'
        ) {
          return parseInt(feature.properties.AEB) === elObj.order
        } else {
          return elObj?.label === feature.properties.NOM
        }
      })
      return {
        weight: 1,
        color: 'white',
        opacity: 1,
        fillColor: element ? self.getColor(element.value) : 'gray',
        fillOpacity: opacityPick / 100,
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.map
  overflow: hidden
  position: relative
  width: 100%

  .map-wrap
    height: 100%
    width: 100%

  .leaflet-container
    background: #fff
    height: 100%

  .map-view-wrapper
    display: flex

    .map-wrap
      height: 100%
      width: 100%

      .leaflet-container
        height: 100%

  .map-legend
    left: vw(20px)
    min-width: vw(300px)
    position: absolute
    top: vw(20px)
    z-index: 2

    &.lite
      left: vw(4px)
      top: vw(4px)

  >>> .leaflet-control-attribution
    m-font-size(12, 14)
    padding: vw(5px)
    text-align: right
    
  >>> .leaflet-left
    z-index: 1001
      
</style>
